export const SET_SITE_DATA = "SET_SITE_DATA";
export const SET_PAGE = "SET_PAGE";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_LOADING = "SET_LOADING";
export const SET_HOMEPAGE_DATA = "SET_HOMEPAGE_DATA";
export const SET_CART_DATA = "SET_CART_DATA";
export const SET_COUPON_DATA = "SET_COUPON_DATA";
export const SET_HEADER_COLOR = "SET_HEADER_COLOR";
export const SET_CART_DETAILS = "SET_CART_DETAILS";
export const SET_SECTION2 = "SET_SECTION2";
export const SET_LANGUAGE_LOAD = "SET_LANGUAGE_LOAD";
export const SET_HEART_DATA = "SET_HEART_DATA";
export const SET_HEADER_TEXT_COLOR = "SET_HEADER_TEXT_COLOR";
export const SET_MEIN_TRAINING_MODAL = "SET_MEIN_TRAINING_MODAL";
export const SET_PROGRAM_LIST = "SET_PROGRAM_LIST";
export const SET_RECIPE_PLAN = "SET_RECIPE_PLAN";

